import React from 'react';
import { useEventContext } from '../../context/EventProvider';

const PrivacyPolicy = () => {
  const {
    event: { url, email, emailSubject, privacyText, privacyLink }
  } = useEventContext();

  return (
    <div className="privacy-policy-wrapper">
      <a
        style={{ color: '#fff' }}
        href={privacyLink}
        target="_blank"
        className="privacy-policy"
      >
        {privacyText}
      </a>
    </div>
  );
};

export default PrivacyPolicy;
